import React from 'react';

const Footer = () => {
  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        <div style={contactInfoStyle}>
          <h3>Contact Information</h3>
          <p>Email: younes.boussoussou24@gmail.com</p>
          <p>Phone: +213774550650</p>
          <p>Address: BORDJ EL BAHRI , ALGERIES , ALGERIA</p>
        </div>
        <div style={copyrightStyle}>
          <p>&copy; 2024 YNS. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

const footerStyle = {
  backgroundColor: 'black',
  color: 'gold',
  padding: '20px 0',
  textAlign: 'center',
  position: 'relative',
  left: 0,
  bottom: 0,
  width: '100%',
  borderTop: '1px solid #ccc',
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

const contactInfoStyle = {
  marginBottom: '10px',
};

const copyrightStyle = {
  marginTop: '10px',
};

export default Footer;
